import { render } from "./Ranking.vue?vue&type=template&id=a228c1b0"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__